import React from 'react';
import PropTypes from 'prop-types';
import {
  NavBar,
  FlexRow,
  Col,
  Heading,
  Body,
  ArrowLeftTailIcon,
  PaxIcon,
  Box,
} from '@edreamsodigeo/prisma-design-system';
import { PriceFreezeDate } from '@/components/PriceFreezeDateTime/PriceFreezeDateTime';

export function AppHeaderMobile({
  departure,
  destination,
  departureDate,
  arrivalDate,
  numberOfPax,
  onBack,
}) {
  return (
    <Box sx={{ position: 'relative' }}>
      <NavBar as="header" effect="elevated">
        <FlexRow
          height="64px"
          px="base"
          justifyContent="space-between"
          alignItems="center"
        >
          <Col onClick={onBack} data-testid="onBack">
            <ArrowLeftTailIcon color="primary.50" size="large" />
          </Col>
          <Col flexGrow={2}>
            <Body textAlign="center">
              <Heading as="h6" type="6" weight="medium" color="neutral.100">
                {departure} - {destination}
              </Heading>
              <Body type="xSmall" color="neutral.70">
                <PriceFreezeDate format={'EEEddMM'} date={departureDate} />
                {arrivalDate ? ' - ' : ' '}
                <PriceFreezeDate format={'EEEddMM'} date={arrivalDate} />
                {' · '}
                <PaxIcon size="small" verticalAlign="text-bottom" />{' '}
                {numberOfPax}
              </Body>
            </Body>
          </Col>
        </FlexRow>
      </NavBar>
    </Box>
  );
}

AppHeaderMobile.propTypes = {
  departure: PropTypes.string.isRequired,
  destination: PropTypes.string.isRequired,
  departureDate: PropTypes.string.isRequired,
  numberOfPax: PropTypes.number.isRequired,
  onBack: PropTypes.func.isRequired,
  arrivalDate: PropTypes.string,
};

AppHeaderMobile.defaultProps = {
  arrivalDate: '',
};
